import { headers } from "../utils/helpers";


async function fetchSource(search = '') {
    this.isLoading = true; 
    try {
        const response = await fetch(`/api/v1/source/?search=${search}`, {
            method: "GET",
            headers: headers,
        });
        const data = await response.json();
        if (data?.success === false) {
            this.showError(data.error)
            return
        }
        this.isLoading = false;
        this.sourceData = data?.data;
    } catch (error) {
        this.showError(error);
    }
    this.isLoading = false;
}


async function fetchAreaGroupPartnerSales(search) {
    this.isLoading = true
    try {
        const response = await fetch(`/api/v2/area-group/?search=${search}`,{
            headers: headers
        });
        const data = await response.json();
        if (data.success == false) {
            this.showError(data.error)
            return
        }
        this.areaData = data.data.area_group
        this.frequentAreas = data.data.frequent_area_group
    }
    catch (err) {
        this.showError(err)
    }
    this.isLoading = false
}


async function fetchPolicyPartnerSales() {
    this.isLoading = true

    try {
        const response = await fetch(`/api/v2/product/?policy_type=${this.policyType}`,{
            headers: headers
        })
        const data = await response.json();
        if (data.success == false) {
            this.showError(data.error)
            return
        }
        this.maxYears = data?.data[0].max_years;
        this.years = this.generateYears(this.maxYears, this.selectedYear)
    }
    catch (err) {
        this.showError(err)
    }
    this.isLoading = false
}


export { fetchPolicyPartnerSales, fetchAreaGroupPartnerSales, fetchSource }